/* =====================================================
  Bioteïne - Cart drawer: Mix & Match side column (desktop only)
  20.10.2026. At >=990px the drawer's Mix & Match block is moved into a
  column left of the drawer panel; below 990px it goes back to its original
  place inside the drawer. Same element, so its cart logic and events are
  untouched.
  ===================================================== */
(function () {
  'use strict';
  function init() {
    var drawer = document.querySelector('[data-bt-cart-drawer]');
    if (!drawer) return;
    var mm = drawer.querySelector('.bt-mm--drawer');
    var panel = drawer.querySelector('.bt-cart-drawer__panel');
    if (!mm || !panel || !window.matchMedia) return;

    var home = document.createComment('bt-mm-drawer-home');
    mm.parentNode.insertBefore(home, mm);
    var side = document.createElement('div');
    side.className = 'bt-cart-drawer__side';
    drawer.insertBefore(side, panel);

    var mq = window.matchMedia('(min-width: 990px)');
    function place() {
      if (mq.matches) {
        if (mm.parentNode !== side) side.appendChild(mm);
        mm.classList.add('bt-mm--side');
      } else {
        if (mm.parentNode === side) home.parentNode.insertBefore(mm, home.nextSibling);
        mm.classList.remove('bt-mm--side');
      }
    }
    place();
    if (mq.addEventListener) mq.addEventListener('change', place);
    else if (mq.addListener) mq.addListener(place);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
